<app-admin-header></app-admin-header>

<div style="border: 1px solid #fff; margin: 80px 150px; border-color: #fff !important; background-color: #fff; font-family: 'Times New Roman', Times, serif;">

    <div *ngIf="isLoading"  class="d-flex text-center justify-content-center mt-3">
        <p class="text-muted">Loading... Please wait</p>
      </div>

      <div *ngIf="isEmpty"  class="d-flex text-center justify-content-center mt-3">
        <p class="text-muted">Error loading Demand Notice</p>
      </div>
    
    <div *ngIf="!isEmpty && !isLoading" style="padding: 30px 40px;">
        
        <div style="position: absolute; margin: 30% 10%; text-align: center; align-self: center; width: 50%; height: 50%; opacity: 0.03;">
            <img src="assets/img/AIRS-Logo.png" alt="logo" style="width: 100%; height: 100%;">
        </div>

        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <div style="margin-right: 15px">
                <img src="assets/img/Anambra-Logo.png" alt="logo" style="width: 100px; height: 100px;">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center;">
                <h6 style="font-size: 24px; text-transform: uppercase; font-weight: bold;">Anambra State</h6>
                <h6 style="font-size: 18px; text-transform: uppercase; font-weight: bold; color: #795B18;">Internal Revenue Central System</h6>
            </div>
            <div style="margin-left: 0px">
                <img src="assets/img/AIRS-Logo.png" alt="logo" style="width: 170px; height: 110px;">
            </div>
        </div>

        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <h5 style="font-size: 15px; text-transform: uppercase; font-weight: bold;">PERSONAL INCOME TAX</h5>
        </div> 

        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-bottom: 30px;;">
            <h5 style="font-size: 22px; text-transform: uppercase; font-weight: bold;">Notice of Assessment</h5>
        </div> 

        <div style="display: flex; flex-direction: row; margin: 10px 0px;">
            <div style="width: 45%;">
                <div style="display: flex; flex-direction: row;">
                    <h6 style="font-size: 13px;; text-transform: uppercase;">INCOME TAX YEAR OF ASSESSMENT:</h6>
                    <h6 style="margin-left: 30px; font-size: 13px;; font-weight: bold;">{{details?.filingYear}}</h6>
                </div>
                <div style="border: 2px dashed black; background: #FFFDF9; width: 100%; height: 170px; display: flex; flex-direction: row; padding: 20px 30px;">

                    <div style="width: 30%; display: block;">
                        <img src="{{details?.photo}}" alt="user photo" style="width: 100px; height: 100px;">                    
                    </div>

                    <div style="width: 70%; display: flex; flex-direction: column;">
                        <!-- <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">NAME:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.displayName}}</h6>
                        </div> -->

                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <!-- <h6 style="font-size: 13px;; text-transform: uppercase;">:</h6> -->
                            <h6 style="width: 100%; font-size: 13px;; text-transform: uppercase;">
                                {{details?.displayName | uppercase}}
                            </h6>
                        </div>
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <!-- <h6 style="font-size: 13px;; text-transform: uppercase;">ADDRESS:</h6> -->
                            <h6 style="width: 100%; font-size: 13px;; text-transform: uppercase;">
                                {{details?.address | uppercase}}
                            </h6>
                        </div>

                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="width: 100%; font-size: 13px;; text-transform: uppercase;">
                                {{details?.phoneNumber }}
                            </h6>
                        </div>

                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="width: 100%; font-size: 13px;; text-transform: lowercase;">
                                {{details?.email}}
                            </h6>
                        </div>
                        <!-- <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">MARITAL STATUS:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">Married</h6>
                        </div> -->
                    </div>
                </div>
            </div>
            <div style="width: 10%;"></div>
            <div style="width: 45%;">
                <div style="display: flex; flex-direction: row; justify-content: end;">
                    <h6 style="font-size: 13px;; text-transform: uppercase;">AIRMS ID:</h6>
                    <h6 style="margin-left: 30px; font-size: 13px;; font-weight: bold; text-transform: uppercase;">{{assessmentId}}</h6>
                </div>
                <div style="border: 2px solid black; width: 100%; height: 170px; display: flex; flex-direction: row; padding: 20px 30px;">
                    <div style="width: 100%; display: flex; flex-direction: column;">
                       
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">ASIN:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.asin}}</h6>
                        </div>
                       
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">Payment Status:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.paymentStatus == 'NOT_PAID' ? 'Not Paid' : 'Paid'}}</h6>
                        </div>
                        <div style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">Approval Status:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.approvalStatus}}</h6>
                        </div>
                        <div *ngIf="details?.reason" style="display: flex; flex-direction: row; margin-bottom: 5px;">
                            <h6 style="font-size: 13px;; text-transform: uppercase;">Reason:</h6>
                            <h6 style="margin-left: 30px; font-size: 13px;; text-transform: uppercase; font-weight: bold;">{{details?.reason}}</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="display: flex; flex-direction: column; margin-top: 30px;">
            <p style="font-size: 13px;">
                Pursuant to section 56 of the Personal Income Tax Act Cap P.8 LFN 2011 as amended, 
                notice is hereby given to you that an assessment of income tax has been made to you, 
                as detailed below, and that the undermentioned tax is payable on or before: 
                <span style="font-weight: bold;">31/12/{{expiryYear}}</span>       
            </p>
            <p style="font-size: 13px; margin-top: 10px;">
                If you dispute this assessment, you may give notice of objection in 
                writing or electronically to the relevant tax authority to 2020 revise this assessment, 
                within time under section 57 of Personal Income Tax Act Cap P.8 LFN 2011 as amended on 
                payment of half the tax assessed
            </p>
        </div>

        <div style="margin: 30px 0px;">
            <table style="border-collapse: collapse; width: 100%; font-size: 13px;">
                <thead style="background-color: #f2f2f2; font-size: 13px;">
                <tr style="font-size: 13px;">
                    
                    <th style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; text-transform: uppercase; width: 50%">
                        ASSESSMENT INFORMATION
                    </th>
                    <th style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; text-transform: uppercase; width: 50%">
                      
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd;">
                        <div style="width: 100%; display: flex; flex-direction: column;">

                            
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Assessment Mode:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.modeOfAssessment == 'TAX_TO_INCOME' ? 'TAX TO INCOME' : 'INCOME TO TAX'}}</h6>
                            </div>
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Occupation:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.sourceOfIncome}}</h6>
                            </div>
                            
                            
                           
                        </div>                
                    </td>

                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Date Created:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.filingDate | date}}</h6>
                            </div>
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Created By:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.assessedBy}}</h6>
                            </div>
                            <div style="display: flex; flex-direction: row; margin-bottom: 10px;">
                                <h6 style="text-transform: uppercase; font-size: 13px;">Approved By:</h6>
                                <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.approvedBy}}</h6>
                            </div>
                           
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <table style="border-collapse: collapse; width: 100%">
                <tbody>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">Gross Income</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.grossIncome | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">TOTAL DEDUCTIONS:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.totalDeduction | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">CONSOLIDATED RELIEF ALLOWANCE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.consolidatedReliefAllowance | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">CHARGEABLE INCOME:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.chargeableIncome | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">TAX DUE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.subTax | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">DEVELOPMENT LEVY PAYABLE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.developmentLevy | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-size: 13px;">Stamp duty Payable</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.stampDuty | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                    <tr style="height: 60px;">
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 70%;">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="width: 100%; text-transform: uppercase; font-weight: bold; font-size: 13px;">TOTAL TAX DUE:</h6>
                        </div>
                    </td>
                    <td style="text-align: left; padding: 5px 20px; border: 1px solid #ddd; width: 30%">
                        <div style="width: 100%; display: flex; flex-direction: column;">
                            <h6 style="margin-left: 30px; text-transform: uppercase; font-weight: bold; font-size: 13px;">{{details?.taxDue | nairaCurrency}}</h6>
                        </div>                
                    </td>
                    </tr>
                </tbody>
            </table>    
        </div>

        <div style="display: flex; flex-direction: column; margin-top: 40px; margin-bottom: 50px;">
            <h4 style="font-size: 20px; text-transform: uppercase; font-weight: bold;">NOTICE:</h4>
            
            <!-- list 1. and 2. -->
            <div style="display: flex; flex-direction: row; margin-top: 20px;">
                <div style="width: 5%; margin-left: 20px;">
                    <h6 style="font-size: 13px; font-weight: bold;">1.</h6>
                </div>
                <div style="width: 95%;">
                    <h6 style="font-size: 13px;">
                        If you do not pay the tax due within the time allowed, the tax authority may 
                        enforce payment of the tax due by distress or sale of your goods and chattels 
                        or by civil proceedings or by criminal prosecution or by any combination of 
                        these methods.
                    </h6>
                </div>
            </div>  

            <div style="display: flex; flex-direction: row; margin-top: 20px;">
                <div style="width: 5%; margin-left: 20px;">
                    <h6 style="font-size: 13px; font-weight: bold;">2.</h6>
                </div>
                <div style="width: 95%;">
                    <h6 style="font-size: 13px;">
                        If you do not pay the tax due within the time allowed, the tax authority may 
                        enforce payment of the tax due by distress or sale of your goods and chattels 
                        or by civil proceedings or by criminal prosecution or by any combination of 
                        these methods.
                    </h6>
                </div>
            </div>

        </div>

        <!-- four buttons across -->

        <div style="display: flex; flex-direction: row; justify-content: space-between; margin-left: 20px; margin-right: 20px; margin-bottom: 50px; ">
           <div style="display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 50px;">
            <div *ngIf="details?.approvalStatus == 'APPROVED'"  class="action-buttons">
                <button  type="button" class="btn query-button" (click)="downloadNotice()"  >Download Demand Notice</button>
                <button *ngIf="details?.paymentStatus != 'PAID'"  type="button" class="btn approve-button">Make Payment</button>
            </div>
           </div>
            
        </div>

        
    </div>

    
</div>

<div   style="display: flex; flex-direction: row; justify-content: space-between; margin-left: 200px; margin-bottom: 50px;">
    <div class="action-buttons">
        <button type="button" class="btn back-button" (click)="goBack()" >Back</button>
        
    </div>
   </div>

<app-footer></app-footer>
